import type { ButtonProps } from "@mui/material/Button";
import type { Theme } from "@mui/material/styles";
import { alpha, createTheme } from "@mui/material/styles";

import darkPalette from "./dark";
import lightPalette from "./light";
import typography from "./typography";

export type AppMode = "light" | "dark";

const buttonDefaultProps: Partial<ButtonProps> = {
    disableElevation: true,
    variant: "contained",
};

export const getTheme = (mode: AppMode): Theme =>
    createTheme({
        palette: mode === "light" ? lightPalette : darkPalette,
        shape: { borderRadius: 8 },
        transitions: {
            // duration: {
            //   shortest: 300,
            //   shorter: 350,
            //   short: 400,
            //   standard: 500,
            //   complex: 600,
            //   enteringScreen: 450,
            //   leavingScreen: 400,
            // },
        },
        typography: typography,
        components: {
            MuiLink: {
                styleOverrides: {
                    root: {
                        textDecoration: "underline",
                        textUnderlineOffset: "4px",
                        "&:hover": {
                            textDecoration: "none",
                        },
                    },
                },
            },
            MuiButton: {
                defaultProps: buttonDefaultProps,
                styleOverrides: {
                    root: {
                        borderRadius: 999,
                    },
                },
            },
            MuiPaper: {
                defaultProps: { elevation: 0 },
                styleOverrides: {
                    root: () => ({ borderRadius: 12 }),
                    outlined: ({ theme }: { theme: Theme }) => ({
                        borderColor: alpha(theme.palette.divider, 0.5),
                    }),
                },
            },
            MuiDrawer: {
                defaultProps: { elevation: 0 },
            },
            MuiDivider: {
                styleOverrides: {
                    root: ({ theme }: { theme: Theme }) => ({
                        borderColor: alpha(theme.palette.divider, 0.6),
                    }),
                },
            },
            MuiOutlinedInput: {
                // defaultProps: { notched: false },
                styleOverrides: {
                    root: ({ theme }: { theme: Theme }) => ({
                        "& fieldset": {
                            borderColor: alpha(
                                theme.palette.text.secondary,
                                0.5,
                            ),
                            transition: theme.transitions.create(
                                ["border-color"],
                                {
                                    duration: theme.transitions.duration.short,
                                },
                            ),
                        },
                        "&:hover fieldset": {
                            borderColor: theme.palette.text.primary,
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: theme.palette.primary.main,
                        },
                        // "&.Mui-focused input": {
                        //   paddingTop: 24,
                        //   paddingBottom: 8,
                        //   lineHeight: 24,
                        // },
                        // "& input:not(:placeholder-shown)": {
                        //   paddingTop: 24,
                        //   paddingBottom: 8,
                        //   lineHeight: 24,
                        // },
                        transition: theme.transitions.create(["border-color"], {
                            duration: theme.transitions.duration.short,
                        }),
                    }),
                },
            },
            // MuiInputLabel: {
            //   styleOverrides: {
            //     root: {
            //       "&.MuiInputLabel-shrink": {
            //         marginTop: 14,
            //         marginBottom: 0,
            //         paddingBottom: 0,
            //       },
            //     },
            //   },
            // },
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        WebkitFontSmoothing: "antialiased",
                        MozOsxFontSmoothing: "grayscale",
                    },
                },
            },
        },
    });
